(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer-links"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var fx = document.querySelectorAll('.dome__fx');
    if (!fx.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // The whole scene is one continuous 2750ms loop with the salvo stagger baked
    // into keyframe %; here we only toggle `is-live`, which flips
    // animation-play-state running/paused. So it plays only while on screen
    // (real idle offscreen — zero CPU/GPU), and resumes in phase on scroll-back.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-live', e.isIntersecting);
      });
    }, { threshold: 0.01 });

    fx.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-system"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.currentScript?.closest('.shopify-section') ?? document;
    const toc = section.querySelector('[data-ds-toc]');
    if (!toc) return;

    const links = new Map();
    for (const a of toc.querySelectorAll('[data-ds-toc-link]')) {
      links.set(a.getAttribute('data-ds-toc-link'), a);
    }

    const anchors = section.querySelectorAll('[data-ds-anchor]');
    if (!('IntersectionObserver' in window) || anchors.length === 0) return;

    function setActive(type) {
      for (const [t, a] of links) {
        if (t === type) {
          a.setAttribute('aria-current', 'location');
          a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        } else {
          a.removeAttribute('aria-current');
        }
      }
    }

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) {
          setActive(visible.target.getAttribute('data-ds-anchor'));
        }
      },
      { rootMargin: '-30% 0px -60% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    for (const a of anchors) io.observe(a);
  })();

  } catch(e) { console.error(e); }
})();
})();
